import {computed, ref} from 'vue';

const competition = ref({});
const isCompetitionFee = computed(() => competition.value?.payPurpose === 'ENTRY_FEE' );

function setCompetition(data) {
    // {payPurpose: 'ENTRY_FEE', payAmount: 123, relatedId: 1001 }    
    
    competition.value = data;
    // console.log('setCompetition ', competition.value);
}
function getData() {
    return competition.value;
}
export function useCompetition() {
  return {
      setCompetition,
      isCompetitionFee,
      getData
  };
}
